import { CurrencyDisplayUtil } from './../../common/currency-display-util';
import { AppConfig } from './../../app.config';
import { SnapshotService } from './../../snapshot/snapshot.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Projection } from '@liquitics/transaction';
import { Correction } from '@liquitics/transaction';

import { CorrectionService } from './../correction.service';
import { CommunicationService } from '../../common/communication.service';
import { ProjectionService } from '../../projection/projection.service';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import * as moment from 'moment';


export const DATE_FORMATS = {
    parse: {
        dateInput: 'YYYY-MM-DD',
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
@Component({
    selector: 'app-manual-correction',
    templateUrl: './manual-correction.component.html',
    styleUrls: ['./manual-correction.component.css'],
    providers: [
        // {provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS},
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ],
})
export class ManualCorrectionComponent implements OnInit {
    currencies: string[];
    directions: string[];
    clients: string[] = [];
    products: string[] = [];
    organizationLevels: string[] = [];
    desks: string[] = [];
    accounts: string[] = [];
    submitResult: string;
    minimumCorrectionAmount = -10000000000;
    maximumCorrectionAmount = 10000000000;

    correctionFormGroup: FormGroup;

    amountDisplay: string;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        private snapshotService: SnapshotService,
        private correctionService: CorrectionService,
        private communicationService: CommunicationService,
        private projectionService: ProjectionService,
        private appConfig: AppConfig) {

        this.currencies = this.appConfig.activeUserProfile.getCurrencies();
        const applicationConfiguration = snapshotService.applicationConfiguration;
        this.clients = this.sortOrEmpty(applicationConfiguration.clients);
        this.products = this.sortOrEmpty(applicationConfiguration.products);
        this.organizationLevels = this.sortOrEmpty(applicationConfiguration.organizationLevels);
        this.desks = this.sortOrEmpty(applicationConfiguration.desks);
        this.accounts = this.sortOrEmpty(Object.keys(applicationConfiguration.accountNames));
        this.directions = ['PAY', 'REC'];

        const correction = data.correction as Correction;
        this.populateDefaults(correction);
        this.correctionFormGroup = new FormGroup({
            'settleDate': new FormControl(moment.utc(correction.settleDate), [
                Validators.required,
            ]
            ),
            'currency': new FormControl(correction.currency, [
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(3),
                currencyValidator(this.currencies),
            ]
            ),
            'direction': new FormControl(correction.direction, [
                Validators.required,
            ]
            ),
            'amount': new FormControl(correction.amount, [
                Validators.required,
            ]
            ),
            'desk': new FormControl(correction.desk, [
                Validators.required,
            ]
            ),
            'changeReason': new FormControl(correction.changeReason, [
                Validators.required,
            ]
            ),
            'account': new FormControl(correction.account, [
                Validators.required,
            ]
            ),
            'organizationLevel': new FormControl(correction.txnOrganizationLevel, [
                Validators.required,
            ]
            ),
            'timeSpecific': new FormControl(correction.txnTimeSpecific, [
                Validators.required,
            ]
            ),
            'settleTime': new FormControl(correction.txnSettleTime, [
                // settleTimeRequiredValidator(correction),
            ]
            ),
            'client': new FormControl(correction.txnClient, [
                Validators.required,
            ]
            ),
            'product': new FormControl(correction.txnProduct, [
                Validators.required,
            ]
            ),
            'clearing': new FormControl(correction.txnClearing, [
                Validators.required,
            ]
            ),


        });
    }

    populateDefaults(correction: Correction) {
        correction.currency = this.currencies[0];
        correction.settleDate = this.appConfig.getTodayString();
        correction.txnTimeSpecific = false;
        correction.txnClearing = false;
    }

    sortOrEmpty(values: string[]): string[] {
        if (!values) {
            return [];
        }
        return values.sort();
    }

    ngOnInit() {
    }

    submit() {
        const correction: Correction = this.data.correction;
        this.buildCorrection(correction);
        // Flip the sign as we force abs in the GUI
        if (correction.direction === 'PAY') {
            correction.amount = - Math.abs(correction.amount);
        } else {
            correction.amount = Math.abs(correction.amount);
        }
        this.correctionService
            .saveCorrection(this.data.correction)
            .then(() => {
                this.communicationService.openSnackBar('Submission Successful', 'Ok');
            })
            .catch((err: any) => {
                this.communicationService.openSnackBar('Submission Failed', 'Dismiss');
            })
            ;

    }

    get settleDate() { return this.correctionFormGroup.get('settleDate'); }
    get currency() { return this.correctionFormGroup.get('currency'); }
    get direction() { return this.correctionFormGroup.get('direction'); }
    get amount() { return this.correctionFormGroup.get('amount'); }
    get desk() { return this.correctionFormGroup.get('desk'); }
    get changeReason() { return this.correctionFormGroup.get('changeReason'); }
    get account() { return this.correctionFormGroup.get('account'); }
    get organizationLevel() { return this.correctionFormGroup.get('organizationLevel'); }
    get timeSpecific() { return this.correctionFormGroup.get('timeSpecific'); }
    get settleTime() { return this.correctionFormGroup.get('settleTime'); }
    get client() { return this.correctionFormGroup.get('client'); }
    get product() { return this.correctionFormGroup.get('product'); }
    get clearing() { return this.correctionFormGroup.get('clearing'); }



    // updateCorrectionAmount(event: string) {
    //     const amount = parseFloat(event);
    //     this.data.correction.amount = amount;
    // }

    buildCorrection(correction: Correction) {
        correction.settleDate = moment.utc(this.settleDate.value).format('YYYY-MM-DD');
        correction.currency = this.currency.value;
        correction.direction = this.direction.value;
        correction.amount = this.amount.value;
        correction.desk = this.desk.value;
        correction.changeReason = this.changeReason.value;
        correction.account = this.account.value;
        correction.txnOrganizationLevel = this.organizationLevel.value;
        correction.txnTimeSpecific = this.timeSpecific.value;
        correction.txnSettleTime = this.settleTime.value;
        correction.txnClient = this.client.value;
        correction.txnProduct = this.product.value;
        correction.txnClearing = this.clearing.value;
        // Value we need to default
        correction.txnSettleDate = correction.settleDate;
        correction.txnCurrency = correction.currency;
        correction.txnDirection = correction.direction;
        correction.txnAmount = correction.amount;
        correction.txnDesk = correction.desk;
        correction.txnAccount = correction.account;
    }

    updateFormFields() {
        const correction: Correction = this.data.correction;
        this.correctionFormGroup.setValue({
            'settleDate': correction.settleDate,
            'currency': correction.currency,
            'direction': correction.direction,
            'amount': correction.amount,
            'desk': correction.desk,
            'changeReason': correction.changeReason,
            'account': correction.account,
            'organizationLevel': correction.txnOrganizationLevel,
            'timeSpecific': correction.txnTimeSpecific,
            'settleTime': correction.txnSettleTime,
            'client': correction.txnClient,
            'product': correction.txnProduct,
            'clearing': correction.txnClearing,
        })
    }

    onFieldChange(event) {
        const correction: Correction = this.data.correction;
        this.buildCorrection(correction);
        this.amountDisplay = CurrencyDisplayUtil.toShortNumber(correction.amount);
        if (correction.txnTimeSpecific) {
            this.correctionFormGroup.get('settleTime').setValidators([Validators.required]);
        } else {
            this.correctionFormGroup.get('settleTime').setValidators([]);
        }
        this.correctionFormGroup.get('settleTime').updateValueAndValidity();
    }
}

export function currencyValidator(currencies: string[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const isValid = currencies.includes(String(control.value).toUpperCase());
        return !isValid ? { 'invalidCurrency': { value: control.value } } : null;
    };
}
